import { useTranslation } from '@web_opxp/language';
import map from 'lodash/map';
import React from 'react';
import { connect } from 'react-redux';
import * as Selectors from '../store/selectors';
import { LegalsActions } from '../store/slice';
import { Continent, CountriesMap, Country, EArticleAlias } from '../types';
import ContinentGroup from './ContinentGroup';
import './CountriesSelectView.scss';

interface OwnProps {
  type: EArticleAlias;
}

interface CountriesSelectViewProps extends OwnProps {
  countries: CountriesMap;
  mostCommon: Country[];
  onCountrySelect: (type: EArticleAlias, id: string, language?: string) => void;
}

export const CountriesSelectViewFC: React.FC<CountriesSelectViewProps> = ({
  countries,
  mostCommon,
  type,
  onCountrySelect,
}) => {
  const { t, language } = useTranslation();
  const selectHandler = (id: string) => onCountrySelect(type, id, language);
  const continentMap = map(countries, (countriesList, continent) => (
    <ContinentGroup
      key={continent}
      continent={continent as Continent}
      countries={countriesList}
      onSelect={selectHandler}
    />
  ));
  return (
    <>
      <h1 className="countries-header">{t(`common.auth:TOU.${type}.Title`)}</h1>
      <p className="countries-intro">{t('common.auth:TOU.Intro')}</p>
      <ContinentGroup
        key={`most-common-countries`}
        countries={mostCommon}
        label={t(`common.auth:TOU.MostCommon`)}
        onSelect={selectHandler}
      />
      {continentMap}
    </>
  );
};

const mapStateToProps = (state: Selectors.IState) => {
  const countries = Selectors.getCountries(state);
  const mostCommon = Selectors.getMostCommonList(state);
  return {
    countries,
    mostCommon,
  };
};

const mapDispatchToProps = {
  onCountrySelect: LegalsActions.legalsRequest,
};

const CountriesSelectView = connect(mapStateToProps, mapDispatchToProps)(CountriesSelectViewFC);

export default CountriesSelectView;
